module.exports = __webpack_public_path__ + "images/brightlease_small0824254d5c146aa53c3ec25c45803fcd.png";